/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest } from "relay-runtime";

import { FragmentRefs } from "relay-runtime";
export type NftStatus_enum = "Auction" | "Listed" | "Owned" | "%future added value";
export type CancelListingModalMutationVariables = {
    creator: string;
    lister: string;
    mint: string;
    txid: string;
};
export type CancelListingModalMutationResponse = {
    readonly update_Nft_by_pk: {
        readonly id: string;
        readonly creatorId: string;
        readonly mint: string;
        readonly priceInLamports: unknown | null;
        readonly status: NftStatus_enum | null;
    } | null;
    readonly insertNftTransaction: {
        readonly " $fragmentRefs": FragmentRefs<"NftTransaction_NftTransactionExpress">;
    };
};
export type CancelListingModalMutation = {
    readonly response: CancelListingModalMutationResponse;
    readonly variables: CancelListingModalMutationVariables;
};



/*
mutation CancelListingModalMutation(
  $creator: String!
  $lister: String!
  $mint: String!
  $txid: String!
) {
  update_Nft_by_pk(pk_columns: {id: $mint}, _set: {priceInLamports: null, status: Owned}) {
    id
    creatorId
    mint
    priceInLamports
    status
  }
  insertNftTransaction(input: {creatorId: $creator, fromUserId: $lister, toUserId: $lister, mint: $mint, txid: $txid, type: ListingCancelled}) {
    ...NftTransaction_NftTransactionExpress
  }
}

fragment NftTransaction_NftTransactionExpress on NftTransactionExpress {
  id
  fromAddress
  mint
  priceInLamports
  timeCreated
  toAddress
  txid
  type
  From {
    id
    username
    ProfilePhoto {
      id
      photoUrl
    }
  }
  To {
    id
    username
    ProfilePhoto {
      id
      photoUrl
    }
  }
}
*/

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "creator"
  },
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "lister"
  },
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "mint"
  },
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "txid"
  }
],
v1 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
},
v2 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "mint",
  "storageKey": null
},
v3 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "priceInLamports",
  "storageKey": null
},
v4 = {
  "alias": null,
  "args": [
    {
      "kind": "Literal",
      "name": "_set",
      "value": {
        "priceInLamports": null,
        "status": "Owned"
      }
    },
    {
      "fields": [
        {
          "kind": "Variable",
          "name": "id",
          "variableName": "mint"
        }
      ],
      "kind": "ObjectValue",
      "name": "pk_columns"
    }
  ],
  "concreteType": "Nft",
  "kind": "LinkedField",
  "name": "update_Nft_by_pk",
  "plural": false,
  "selections": [
    (v1/*: any*/),
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "creatorId",
      "storageKey": null
    },
    (v2/*: any*/),
    (v3/*: any*/),
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "status",
      "storageKey": null
    }
  ],
  "storageKey": null
},
v5 = [
  {
    "fields": [
      {
        "kind": "Variable",
        "name": "creatorId",
        "variableName": "creator"
      },
      {
        "kind": "Variable",
        "name": "fromUserId",
        "variableName": "lister"
      },
      {
        "kind": "Variable",
        "name": "mint",
        "variableName": "mint"
      },
      {
        "kind": "Literal",
        "name": "price",
        "value": null
      },
      {
        "kind": "Variable",
        "name": "toUserId",
        "variableName": "lister"
      },
      {
        "kind": "Variable",
        "name": "txid",
        "variableName": "txid"
      },
      {
        "kind": "Literal",
        "name": "type",
        "value": "ListingCancelled"
      }
    ],
    "kind": "ObjectValue",
    "name": "input"
  }
],
v6 = [
  (v1/*: any*/),
  {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "username",
    "storageKey": null
  },
  {
    "alias": null,
    "args": null,
    "concreteType": "Photo",
    "kind": "LinkedField",
    "name": "ProfilePhoto",
    "plural": false,
    "selections": [
      (v1/*: any*/),
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "photoUrl",
        "storageKey": null
      }
    ],
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "CancelListingModalMutation",
    "selections": [
      (v4/*: any*/),
      {
        "alias": null,
        "args": (v5/*: any*/),
        "concreteType": "NftTransactionExpress",
        "kind": "LinkedField",
        "name": "insertNftTransaction",
        "plural": false,
        "selections": [
          {
            "args": null,
            "kind": "FragmentSpread",
            "name": "NftTransaction_NftTransactionExpress"
          }
        ],
        "storageKey": null
      }
    ],
    "type": "mutation_root",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "CancelListingModalMutation",
    "selections": [
      (v4/*: any*/),
      {
        "alias": null,
        "args": (v5/*: any*/),
        "concreteType": "NftTransactionExpress",
        "kind": "LinkedField",
        "name": "insertNftTransaction",
        "plural": false,
        "selections": [
          (v1/*: any*/),
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "fromAddress",
            "storageKey": null
          },
          (v2/*: any*/),
          (v3/*: any*/),
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "timeCreated",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "toAddress",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "txid",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "type",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "concreteType": "User",
            "kind": "LinkedField",
            "name": "From",
            "plural": false,
            "selections": (v6/*: any*/),
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "concreteType": "User",
            "kind": "LinkedField",
            "name": "To",
            "plural": false,
            "selections": (v6/*: any*/),
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ]
  },
  "params": {
    "cacheID": "a43d2854f8b379b15d6f32ea072a9858",
    "id": null,
    "metadata": {},
    "name": "CancelListingModalMutation",
    "operationKind": "mutation",
    "text": "mutation CancelListingModalMutation(\n  $creator: String!\n  $lister: String!\n  $mint: String!\n  $txid: String!\n) {\n  update_Nft_by_pk(pk_columns: {id: $mint}, _set: {priceInLamports: null, status: Owned}) {\n    id\n    creatorId\n    mint\n    priceInLamports\n    status\n  }\n  insertNftTransaction(input: {creatorId: $creator, fromUserId: $lister, toUserId: $lister, mint: $mint, txid: $txid, type: ListingCancelled}) {\n    ...NftTransaction_NftTransactionExpress\n  }\n}\n\nfragment NftTransaction_NftTransactionExpress on NftTransactionExpress {\n  id\n  fromAddress\n  mint\n  priceInLamports\n  timeCreated\n  toAddress\n  txid\n  type\n  From {\n    id\n    username\n    ProfilePhoto {\n      id\n      photoUrl\n    }\n  }\n  To {\n    id\n    username\n    ProfilePhoto {\n      id\n      photoUrl\n    }\n  }\n}\n"
  }
};
})();
(node as any).hash = 'ad57907cdaaf7ae559c7e95e45116075';
export default node;
